$(document).ready(function () {
  // 案例彙整頁
  if ($('.frame').data('page') == 'showcases') {
    const showcaseBannerAni = gsap.timeline();
    showcaseBannerAni
      .from(".showcase-hand-img", { delay: 0.1, duration: 0.5, y: 0, x: -180, ease: 'circ.out' })
      .from("#showcaseContent", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from("#showcaseVideo", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from("#showcaseVideo_bg", { duration: 0.3, ease: 'circ.out', attr: { fill: '#C4DCEE',}})
      .from("#showcaseVideo_icon", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from(".showcase_bn_arrow", { delay: 0.5, duration: 0.5, opacity: 0, y: -20, stagger: 0.5, repeat: -1, repeatDelay: 3, })

    

    // cases filter collapse
    const $collapse_btn = $('#js-showcase-collapse-toggle-btn');
    const $collapse_content = $('#js-showcase-collapse-content');
    $collapse_btn.on('click', function() {
      // 要關閉
      if ( $collapse_content.hasClass('show') ) {
        $collapse_btn.removeClass('active');
        $collapse_content.removeClass('show');
        $collapse_content.css('height', '0px');
      // 要開啟
      } else {
        $collapse_btn.addClass('active');
        $collapse_content.addClass('show');
        $collapse_content.css('height', $collapse_content[0].scrollHeight + 'px');
      }
    });
    let casesResizeTimer; // resize計時器
    $(window).on('resize', function() {
      clearTimeout(casesResizeTimer);
      casesResizeTimer = setTimeout(function () {
        // 如果目前 collapse content 開著, 就重新設定高度
        if ( $collapse_content.hasClass('show') ) {
          $collapse_content.css('height', 'auto');  // 先將高度設定為auto, 不然無法重新抓到正確高度
          requestAnimationFrame(() => {
            $collapse_content.css('height', $collapse_content[0].scrollHeight + 'px'); // 重新取得高度
          });
        }
      }, 200);
    });
  }

  // 案例內頁
  if ($('.frame').data('page') == 'showcase-inner') {
    // showcase
    if ( $('#showcaseSlider').length > 0 ) {
      var showcaseSlider = new Swiper('#showcaseSlider', {
        effect: 'fade',
        autoplay: {
          delay: 6000,
        },
        speed: 1500,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }
});
